import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function animation() {
	gsap.to(".c-image-shadow img", {		
	  scrollTrigger: {
	    scrub: true,
			trigger: '.c-image-shadow'
	  }, 
	  yPercent: -20,
	  ease: "none"
	});		
	
	$('.c-content-row-image').each(function() {
		var trigger          = this,
				$imageCollection = $(this).find('.c-image-collection'),
				$background      = $imageCollection,
				isSeparated      = $(this).hasClass('c-image-collection--separated'),
				$targets         = $imageCollection.find(".c-image-collection_grid-item");
		
		// Bail if no targets found
		if( $targets.length === 0 ) return; 
		
		// Parallax background elements
		gsap.to($background, {
			scrollTrigger: {
				scrub: true,
				trigger: trigger,
				start: 'top center'	
			},
			yPercent: 7.5,
			ease: 'none'
		});
		
		// Parallax image collection grid items
		if( isSeparated ) {			
			gsap.to($targets, {		
				scrollTrigger: {
					scrub: true,
					trigger: trigger,
					start: "top center"
				},
				y: (i, target) => { 
					var modifier  = -100;
					
					console.log(modifier * target.dataset.speed);
					
					return modifier * target.dataset.speed;
				},
				ease: "none"
			});	
		}				
		else {			
			gsap.to($targets, {		
				scrollTrigger: {
					scrub: true,
					trigger: trigger,
					start: "top center"
				},
				yPercent: -30,
				ease: "none"
			});			
		}
	})
}

export { animation }